import { twMerge } from "tailwind-merge";
import BgImage from "./BgImage";

type FloatingItemProps = React.PropsWithChildren & {
  title: string;
  image: string;
};

const FloatingItem: React.FC<FloatingItemProps> = (props) => {
  return (
    <li
      className={twMerge(
        "group w-full",
        "grid place-self-start",
        "md:grid-cols-6",
        "lg:odd:-mt-20",
      )}
    >
      <BgImage
        className={twMerge(
          "relative -z-10 aspect-[4/3]",
          "md:col-span-4",
          "md:group-even:order-2",
        )}
        src={props.image}
      />
      <div
        className={twMerge(
          "space-y-4 place-self-center bg-white py-4 pb-8 text-[13px] leading-relaxed",
          "max-md:w-full",
          "md:px-4",
          "md:col-span-2",
          "md:group-odd:-ml-20",
          "md:group-even:-mr-20",
          "md:group-even:text-right",
        )}
      >
        <div
          className={twMerge(
            "[counter-increment:list-item]",
            "before:content-[counter(list-item)]",
            "border-b-4 pb-4 text-4xl font-thin",
          )}
        />
        <h3 className="font-medium leading-normal">{props.title}</h3>
        {typeof props.children === "string" ? (
          <p>{props.children}</p>
        ) : (
          props.children
        )}
      </div>
    </li>
  );
};

export default FloatingItem;
